import React, { useState } from 'react'
import axios from 'axios'
import RenderRazorpay from './RenderRazorpay'
import { baseUrl } from '../../services/PostAPI'
import { Button } from 'primereact/button'
import useIsMobile from '../../common/MobileDeviceHook'

const PaymentComponent = (props) => {
  const { plansList, plot, handlePayment } = props.paymentProps
  const isMobile = useIsMobile()
  const [displayRazorpay, setDisplayRazorpay] = useState(false)
  const [showAllFeatures, setShowAllFeatures] = useState(false)
  const [orderDetails, setOrderDetails] = useState({
    orderId: null,
    currency: null,
    amount: null
  })


  const handleCreateOrder = async (plan) => {
    const token = localStorage.getItem('token')
    setDisplayRazorpay(false);
    try {
      const response = await axios.post(
        `${baseUrl}/payment/create-order`,
        {
          plan: {
            id: plan?.id ?? '',
            amount: plan?.amount ?? ''
          },
          plotId: plot
        },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      )

      const data = response.data
      if (data && data.orderId) {
        setOrderDetails({
          orderId: data.orderId,
          currency: data.currency || 'INR',
          amount: data.amount || 0
        })
        setDisplayRazorpay(true)
      }
    } catch (error) {
      console.log('Error creating order', error)
    }
  }

  const PlanHeader = ({ planName }) => (
    <div className="text-900 font-medium text-xl mb-2 text-center">{planName}</div>
  )
  const PlanPrice = ({ amount }) => (
    <>
      <hr className="my-3 mx-0 border-top-1 border-none surface-border" />
      <div className="flex align-items-center justify-content-center">
        <span className="font-bold text-2xl ">{amount ?? ''}</span>
        <span className="ml-2 font-medium text-600">
          <i className="pi pi-indian-rupee"></i>
          <span className='text-xl'> per plot</span>
        </span>
      </div>
      <hr className="my-3 mx-0 border-top-1 border-none surface-border" />
    </>
  )

  const PlanFeatures = ({ availableCount, planType }) => {
    const isPremium = planType?.toLowerCase() === 'premium'

    const premiumFeatures = [
      'Get Gat/Survey Number Location',
      'PDF Report',
      'Get Gat/Survey Number Direction',
      'Custom Measurement Tool',
      'Calculate Gat/Survey Number Area',
      'Nearby Road/Village/City Information',
      'Adjacent Plots Details (Direction-wise)',
      'Land Boundary (4 Coordinate Points)',
      'Map Snapshot',
      `${availableCount ?? ''} views`
    ]

    const displayedFeatures = showAllFeatures ? premiumFeatures : premiumFeatures.slice(0, 5)

    return (
      <div className="flex-grow-1 mb-4">
        {!isPremium && (
          <ul className="list-none p-0 m-0">
            <li className="flex align-items-center mb-3">
              <i className="pi pi-check-circle text-green-500 mr-2"></i>
              <span className="text-900">Get Gat/Survey Number Location</span>
            </li>
            <li className="flex align-items-center mb-3">
              <i className="pi pi-check-circle text-green-500 mr-2"></i>
              <span className="text-900">PDF Report</span>
            </li>
             <li className="flex align-items-center mb-3">
              <i className="pi pi-check-circle text-green-500 mr-2"></i>
              <span className="text-900">Get Gat/Survey Number Direction</span>
            </li>
             <li className="flex align-items-center mb-3">
              <i className="pi pi-check-circle text-green-500 mr-2"></i>
              <span className="text-900">Custom Measurement Tool</span>
            </li>
            <li className="flex align-items-center mb-3">
              <i className="pi pi-check-circle text-green-500 mr-2"></i>
              <span className="text-900">{availableCount ?? ''} views</span>
            </li>
          </ul>
        )}
        {isPremium && (
          <div>
            <ul className="list-none p-0 m-0">
              {displayedFeatures.map((feature, index) => (
                <li key={index} className="flex align-items-center mb-3">
                  <i className="pi pi-check-circle text-green-500 mr-2"></i>
                  <span className="text-900">{feature}</span>
                </li>
              ))}
            </ul>
            {premiumFeatures.length > 5 && (
              <div className="text-left mt-3">
                <button
                  onClick={() => setShowAllFeatures(!showAllFeatures)}
                  className="text-primary cursor-pointer border-none bg-transparent text-sm font-bold flex align-items-center"
                  style={{ padding: '4px 8px' }}
                >
                  {showAllFeatures ? (
                    <>
                      See less <i className="pi pi-chevron-up ml-1"></i>
                    </>
                  ) : (
                    <>
                      More features <i className="pi pi-chevron-down ml-1"></i>
                    </>
                  )}
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    )
  }

  const PlanButton = ({ onClick }) => (
    <div className="mt-auto">
      <hr className="mb-3 mx-0 border-top-1 border-none surface-border" />
      <Button
        onClick={onClick}
        label="Select Plan"
        className="p-3 w-full bg-primary border-none border-round-md cursor-pointer text-white font-semibold"
      ></Button>
    </div>
  )

  return (
    <div className="w-full">
      <div className="surface-grou px-1 py-1 md:px-6">
        <div className=" font-bold text-4xl mb-1 text-center">
          Plan Details
        </div>

        {!isMobile && (
          <div className="grid">
            {plansList?.map((plan, index) => (
              <div key={index} className="col-6 md:6 p-3">
                <div className="p-3 h-full">
                  <div
                    className="shadow-2 p-5 h-full flex flex-column surface-card"
                    style={{ borderRadius: '6px', height: '400px' }}
                  >
                    <PlanHeader planName={plan.name} />
                    <PlanPrice amount={plan?.amount} />
                    <PlanFeatures
                      availableCount={plan?.availableCount}
                      planType={plan?.name}
                    />
                    <PlanButton onClick={() => handleCreateOrder(plan)} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {isMobile && (

          <div className="grid gap-3">
            {plansList?.map((plan, index) => (
              <div key={index} className="col-12 md:6 p-3">
                <div className="p-3 h-full">
                  <div
                    className="shadow-2 p-5 h-full flex flex-column surface-card"
                    style={{ borderRadius: '6px', height: '350px' }}
                  >
                    <PlanHeader planName={plan.name} />
                    <PlanPrice amount={plan?.amount} />
                    <PlanFeatures
                      availableCount={plan?.availableCount}
                      planType={plan?.name}
                    />
                    <PlanButton onClick={() => handleCreateOrder(plan)} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}


      </div>
      {displayRazorpay && (
        <RenderRazorpay
          amount={orderDetails.amount}
          currency={orderDetails.currency}
          orderId={orderDetails.orderId}
          keyId={process.env.REACT_APP_RAZORPAY_KEY_ID}
          keySecret={process.env.REACT_APP_RAZORPAY_KEY_SECRET}
          handlePayments={handlePayment}
          plot={plot}
        />
      )}
    </div>
  )
}

export default PaymentComponent
